function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "#5284FF",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M29.5778 0H28.488v3.2727h1.0898c.8954 0 1.6239.7323 1.6239 1.6323v8.19c0 .9008-.7285 1.6323-1.6239 1.6323H28.488V18h1.0898c2.6934 0 4.8797-2.1968 4.8797-4.905v-8.19C34.4575 2.1976 32.272 0 29.5778 0"
}), React.createElement("path", {
  d: "M23.1278 2.9338c-.6357-.639-1.6661-.639-2.3018 0-.354.356-.5039.8338-.464 1.2985l-.013-.005v3.1362h-4.8837V4.9048c0-2.7073-2.1855-4.905-4.8797-4.905H4.8798c-2.6934 0-4.8796 2.1969-4.8796 4.905v8.19c0 2.7074 2.1854 4.905 4.8796 4.905h5.7058c2.6934 0 4.8797-2.1968 4.8797-4.905v-2.4586h4.8837v3.4094l.0122-.0058c.0301.374.1799.7405.4648 1.026.6357.639 1.6661.639 2.3018 0l4.8838-4.909c.6357-.639.6357-1.6749 0-2.3139l-4.8838-4.909z"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 35,
    height: 18
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/Migration.a646ac81.svg";
export { SvgComponent as ReactComponent };